import { PROVIDER_VERSION_ARTIFACTS_COLUMN_ID } from "../constants";
import ProviderVersionArtifactsDownloadCell from "./DownloadCell";
import ProviderVersionArtifactsNameCell from "./NameCell";
import ProviderVersionArtifactsSizeCell from "./SizeCell";

export const PROVIDER_VERSION_ARTIFACTS_TABLE_CELLS = {
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.NAME]: ProviderVersionArtifactsNameCell,
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.SIZE]: ProviderVersionArtifactsSizeCell,
  [PROVIDER_VERSION_ARTIFACTS_COLUMN_ID.DOWNLOAD]: ProviderVersionArtifactsDownloadCell,
};
